export const guaranteeConstants = {
  GUARANTEE_TABS: 'GUARANTEE_TABS',
};